import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { JobDashboard } from "@/features/job-post/dashboard/job-dashboard";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/jobs/post/dashboard/$id/",
)({
  component: AdminJobDashboard,
});

// Dashboard Component
function AdminJobDashboard() {
  const { id } = Route.useParams();
  const { user } = Route.useRouteContext();
  return <JobDashboard jobId={id} user={user} />;
}
